export default __webpack_public_path__ + "static/media/case1.301dc1cf.jpg";